module.exports = __webpack_public_path__ + "static/media/abstract5.47b02d2c.jpg";